import { AbstractRemoveValueOfArrayCommand } from "./AbstractRemoveValueOfArrayCommand";

export class RemoveValueOfArrayCommand<TSource, TValue> extends AbstractRemoveValueOfArrayCommand<TSource, TValue> {
  constructor(private readonly _readArray: (s: TSource) => TValue[], index: number) {
    super(index);
  }

  protected readArray(source: TSource): TValue[] {
    return this._readArray(source);
  }
}
